/** 技术问题最大长度 */
export const SPECIFICATION_TECHNICAL_QUESTION_MAX_LENGTH = 8000;

/** 技术手段最大长度 */
export const SPECIFICATION_TECHNICAL_SOLUTION_MAX_LENGTH = 8000;

/** 技术功效最大长度 */
export const SPECIFICATION_TECHNICAL_BENEFIT_MAX_LENGTH = 8000;

/** 实施例最大长度 */
export const SPECIFICATION_EMBODIMENT_MAX_LENGTH = 8000;

/** 最大上传图片数量 */
export const SPECIFICATION_MAX_FIGURES_COUNT = 20;

/** 最大提取图片数量 */
export const SPECIFICATION_MAX_EXTRACTED_FIGURES_COUNT = 25;
